export function toSnakeCase(str: string): string {
  return str.replace(/([A-Z])/g, "_$1").toLowerCase();
}

export function capitalize(s: string): string {
  s = s.trim();
  if (s) {
    s = s.charAt(0).toUpperCase() + s.substring(1);
    if (s.toUpperCase() === s) {
      s = s.charAt(0) + s.substring(1).toLowerCase();
    }
  }
  return s;
}

export function uncapitalize(s: string): string {
  s = s.trim();
  if (s) {
    s = s.charAt(0).toLowerCase() + s.substring(1);
  }
  return s;
}
export function formatFileSize(sizeInBytes: number): string {
  if (sizeInBytes <= 0) {
    return "0";
  } else if (sizeInBytes < 10000) {
    return sizeInBytes.toString();
  } else if (sizeInBytes < 10000000) {
    return `${Math.round(sizeInBytes / 1000)} KB`;
  } else {
    return `${Math.round(sizeInBytes / 1000000)} MB`;
  }
}
